import { GQLBillingPeriod } from '@upheal/graphql/definitions/schema.generated';
import { DateTime } from 'luxon';

export const BillingPeriodType = {
    Yearly: 'yearly',
    Monthly: 'monthly',
} as const;

export type BillingPeriodType =
    (typeof BillingPeriodType)[keyof typeof BillingPeriodType];

export const billingPeriodToText = (
    billingPeriod: GQLBillingPeriod,
    planId: string,
) => {
    if (planId === 'group' || planId === 'enterprise') {
        // Group/enterprise plans have always full month billing period
        // and purchase date doesn't matter
        return DateTime.now().toFormat('LLLL yyyy');
    }

    const startFormatted = billingPeriod
        ? DateTime.fromISO(billingPeriod.start).toLocal().toLocaleString({
              month: 'short',
              day: 'numeric',
              year: 'numeric',
          })
        : '';
    const endFormatted = billingPeriod
        ? DateTime.fromISO(billingPeriod.end).toLocal().toLocaleString({
              month: 'short',
              day: 'numeric',
              year: 'numeric',
          })
        : '';

    return `${startFormatted} - ${endFormatted}`;
};

export const getBillingPeriodTypeDisplayName = (
    billingPeriodType: BillingPeriodType,
) => {
    return billingPeriodType === BillingPeriodType.Yearly
        ? 'annually'
        : 'monthly';
};
